import { ENDPOINTS } from '../constants/api';
/**
 * Request to get white label.
 *
 */
export function getWhiteLabels() {
    let endpoint = ENDPOINTS.whiteLabelData;
    return window.axios.get(endpoint);
  }


// WEBPACK FOOTER //
// ./src/api/white-label.js